import React from "react";
import { useNavigate } from "react-router-dom";
import { useMemberPurchases } from "./portalUtils";

/** Header pill for members: credits left on their active passes (or "Unlimited"); opens My Account › Passes. */
export default function MemberCreditsPill() {
  const navigate = useNavigate();
  const { loading, summary } = useMemberPurchases();
  if (loading) return null;
  const unlimited = summary.unlimited;
  const n = summary.credits;
  const label = unlimited ? "Unlimited" : `${n === 1 ? "credit" : "credits"} left`;
  const detail = unlimited ? summary.unlimitedName : summary.mainName;
  return (
    <button
      type="button"
      onClick={() => navigate("/members/purchases")}
      aria-label={unlimited ? `Unlimited credits with ${detail}` : `${n} ${label}${detail ? `, ${detail}` : ""}`}
      className="inline-flex h-10 items-center gap-2 rounded-full border border-[#E3DCE6] bg-white py-1 pl-1 pr-3.5 text-sm font-extrabold text-gray-900 hover:bg-[#FAF8FB]"
    >
      <span className="flex h-8 min-w-8 items-center justify-center rounded-full bg-[#F3E9FF] px-1.5 text-[13px] font-black text-[#6A00BA]">{unlimited ? "∞" : n}</span>
      <span className="hidden sm:inline">{label}</span>
      {detail && <span className="hidden max-w-[12rem] truncate text-gray-500 lg:inline">· {detail}</span>}
    </button>
  );
}
